import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button, FormControl, InputLabel, FormLabel } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import SearchSelect from 'react-select';
import styles from '../../styles/app';

class AddDepartmentForm extends Component {

    state = {
        taskType: { value: "", label: "İş Tipini Seçiniz" },
    }

    handleTaskTypeChange = async (taskType) => {
        this.setState({ taskType })
    }
    render() {
        const { classes } = this.props;
        return (
            <form className={classes.form} onSubmit={(e) => { e.preventDefault(); this.props.onSubmitForm(e, this.state) }}>
                <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="name">Departman Adı</InputLabel>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                    />
                </FormControl>
                <FormControl required style={{ marginBottom: "15px", marginTop: "20px", width: "100%" }}>
                    <FormLabel>İş Tipi</FormLabel>
                    <br />
                    <SearchSelect
                        value={this.state.taskType}
                        onChange={this.handleTaskTypeChange}
                        options={
                            this.props.taskTypes.map((taskType) => {
                                return { value: taskType._id, label: taskType.name }
                            })
                        }
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    Departmanı Kaydet
                </Button>
            </form>
        )
    }
}

AddDepartmentForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(AddDepartmentForm);